<template>
  <div class="warn-num">
    <custom-plane>
      <div class="warn-num-content">
        <div class="num-container">
          <div class="num-item">
            <div class="title">告警数量</div>
            <div class="sub-title error-color">{{ totalNum }}</div>
          </div>
          <div class="num-item">
            <div class="title">处理数量</div>
            <div class="sub-title normal-color">{{ processedNum }}</div>
          </div>
          <div class="num-item">
            <div class="title">未处理数量</div>
            <div class="sub-title error-color">{{ untreatedNum }}</div>
          </div>
        </div>
      </div>
    </custom-plane>
  </div>
</template>

<script>
export default {
  props: {
    count: Object,
  },
  computed: {
    totalNum() {
      if (this.count?.count?.total != undefined) {
        return this.count.count.total;
      }
      return "-";
    },
    processedNum() {
      if (this.count?.count?.processed != undefined) {
        return this.count.count.processed;
      }
      return "-";
    },
    untreatedNum() {
      if (this.count?.count?.untreated != undefined) {
        return this.count.count.untreated;
      }
      return "-";
    },
  },
};
</script>

<style lang="scss" scoped>
.warn-num {
  width: 416px;
  height: 132px;
  .warn-num-content {
    padding-top: 20px;
    padding-left: 34px;
    color: #ffffff;
    .num-container {
      display: flex;
      height: 92px;
      padding-right: 33px;
      display: flex;
      justify-content: space-between;
    }
    .num-item {
      width: 94px;
      text-align: center;
      .title {
        font-weight: 500;
        font-size: 18px;
        line-height: 27px;
      }
      .sub-title {
        margin-top: 10px;
        font-family: "dina";
        font-weight: 500;
        font-size: 48px;
        line-height: 55px;
      }
    }
  }
}
</style>
